import React, { Component, Fragment } from 'react'
import Breadcrumb from '../../components/organism/Breadcrumb'
import { Link } from 'react-router-dom'

export default class LeakageReveil extends Component {

    render() {
        return (
            <Fragment>
                <Breadcrumb titre='Leakage' ico='ico--leakage' />
                <div className="vertical-center text-center wrapper-90">
                    <div className="ico__xl ico--compass ico--center"></div>
                    <p className="vertical-center__item text-center mb-xxl">Placer l’aimant sur la pastille verte au dos du boitier. Dans l’application Metertool sélectionner le réseau Sigfox ou loRa le plus performant sur votre lieu de pose.</p>
                    <Link className="btn btn-primary mt-xxl" to="LeakageReveil">Suivant</Link>
                    <blockquote>
                        * Pour plus d'information, consulter le mode d'emploi.
                    
                    </blockquote>
                </div>
            </Fragment>
        )
    }
};